import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import axios from "axios";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_DASHBOARD_API_URL,
});

const ip = axios.get("https://api.ipify.org").then((res) => {
  return res.data;
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token fromauthorization: token ? `Bearer local storage if it exists
  const token = localStorage.getItem("token");

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const authLinkPublic = setContext(async (_, { headers }) => {
  const token = localStorage.getItem("qapiToken");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "X-Forwarded-For": `${await ip}`,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

const linkPublic = ApolloLink.from([
  authLinkPublic,
  createHttpLink({
    uri: process.env.REACT_APP_DEMO_API_URL,
  }),
]);

const clientPublic = new ApolloClient({
  link: linkPublic,
  cache: new InMemoryCache(),
});

class GraphQLApiService {
  getMetadata() {
    const token = localStorage.getItem("token");
    let result = null;
    if (token) {
      const parts = token.split(".");
      if (parts[1]) {
        result = JSON.parse(atob(parts[1]))[
          "https://dashboard-api.qtravel.ai/app_metadata"
        ];
      }
    }
    // result.qapi_token = 'eyJhbGciOiJIUzI1NiJ9.eyJwYXJ0bmVyX2lkIjoxfQ.U3rcJMi-ntd--X7qjNNA3wpFtyXnSvp1JFEumW7K3G4';
    return result;
  }
  query(query: any, variables: any) {
    return client.query({ query, variables });
  }

  queryPublic(query: any, variables: any) {
    return clientPublic.query({ query, variables });
  }
  queryPublicNetworkOnly(query: any, variables: any) {
    return clientPublic.query({
      query,
      variables,
      fetchPolicy: "network-only",
    });
  }
  mutatePublic(mutation: any, variables: any) {
    return clientPublic.mutate({ mutation, variables });
  }
}
export const graphQLApiService = new GraphQLApiService();
